<template>
  <div class="car">
    <div class="row">
      <div class="col-sm-6 col-md-4">
        <h4>
          <router-link :to="`/fleet/vehicles/${car.uuid}`">
          #{{ car.convadisId }} {{ car.name }}
          </router-link>
        </h4>
        <img style="max-height: 100px; max-width: 150px; margin: 10px 0;"
        :src="carImage"/>
        <p>
          <strong>Features:</strong>
          <template v-for="feature in car.CarFeatures">
            <span class="fa fa-lg fa-fw"
            :class="[
              feature.icon,
              {
                'fab': feature.icon === 'fa-bluetooth',
                'fa': feature.icon !== 'fa-bluetooth'
              }
            ]" :title="feature.name"></span>
          </template>
        </p>
        <p><strong>Registration:</strong> {{ car.rego }}</p>
        <p><strong>Last Service Date:</strong> {{ car.lastServiceDate | short_date_format }}</p>
        <p><strong>Model:</strong> {{ car.CarType.name }}</p>
        <template v-if="car.Lot">
          <p><strong>Address: </strong> {{ car.Lot.address }}</p>
          <p><strong>Lot Note:</strong> {{ car.Lot.addressMemo }}</p>
          <p><strong>Bays:</strong> {{ car.Lot.bays }}</p>
          <img :src="lotLink" alt="Lot Location">
        </template>
        <template v-else>
          <span class="label big-label label-danger">Car Not On Lot</span>
        </template>
      </div>
      <div class="col-sm-6 col-md-8">
        <h4>Latest Note</h4>
        <template v-if="car.AccountNotes.length > 0">
          <div class="list-group-item">
            <account-note-display :data="car.AccountNotes[0]">
            </account-note-display>
          </div>
        </template>
        <p class="list-group-item" v-else>
          No Notes have been made for this car
        </p>
        <h4>Latest Reservation</h4>
        <template v-if="car.Reservations.length > 0">
          <div class="list-group-item">
            <reservation-display :data="car.Reservations[0]">
            </reservation-display>
          </div>
        </template>
        <p class="list-group-item" v-else>
          No Reservations have been made for this application
        </p>
      </div>
    </div>
    <div class="toolbar text-right">
      <dropdown-input label="Car Commands"
        label-icon="fa-wifi"
        :actions="carCommands"
        :dropup="true"
        @action="executeAction($event, car)">
      </dropdown-input>
      <dropdown-input label="Actions"
        label-icon="fa-car"
        :actions="carActions(car)"
        :dropup="true"
        @action="executeAction($event, car)">
      </dropdown-input>
      <a target="_blank" class="btn btn-default" :href="googleLink">
        <span class="fa fa-map"></span> Map
      </a>
      <router-link class="btn btn-default"
        :to="`/fleet/vehicles/${car.uuid}`">
        <span class="fa fa-search"></span> View
      </router-link>
    </div>
  </div>
</template>

<script>
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import ReservationDisplay from '@/components/displays/ReservationDisplay'
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapActions, mapGetters } from 'vuex'
import {
  INSTANT_RESERVATION,
  UNLOCK_CAR,
  LOCK_CAR,
  IGNITION_ON,
  IGNITION_OFF,
  IMMOBILIZE_VEHICLE,
  GPS_LOCATION,
  NEW_RESERVATION,
  NEW_MAINTENANCE,
  EDIT_CAR,
  MOVE_CAR,
  REPORT_DAMAGE,
  ADD_CAR_NOTE
} from '@/vuex/types'

export default {
  components: {
    AccountNoteDisplay,
    DropdownInput,
    ReservationDisplay
  },
  name: 'Car',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    googleLink () {
      if (this.car.Lot) {
        return 'https://maps.google.com/?q=' +
        this.car.Lot.latitude + ',' +
        this.car.Lot.longitude
      }
    },
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.car.CarType.AmazonImage.objectKey
    },
    lotLink () {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' +
      this.car.Lot.latitude + ',' + this.car.Lot.longitude +
      '&zoom=17&size=250x250&maptype=roadmap&markers=color:red%7Clabel:C%7C' +
      this.car.Lot.latitude + ',' + this.car.Lot.longitude +
      '&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'
    },
    car () {
      return {
        CarType: {
          AmazonImage: {
            objectKey: 'spacer.gif'
          }
        },
        Lot: {},
        Reservations: [],
        AccountNotes: [],
        ...this.object,
        ...this.updatedCar
      }
    },
    ...mapGetters([
      'carCommands',
      'carActions'
    ])
  },
  data () {
    return {
      updatedCar: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedCar = result.updated
    },
    ...mapActions([
      INSTANT_RESERVATION,
      UNLOCK_CAR,
      LOCK_CAR,
      IGNITION_ON,
      IGNITION_OFF,
      IMMOBILIZE_VEHICLE,
      GPS_LOCATION,
      NEW_RESERVATION,
      NEW_MAINTENANCE,
      EDIT_CAR,
      MOVE_CAR,
      REPORT_DAMAGE,
      ADD_CAR_NOTE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Car.vue